import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SplashScreenModule } from './_metronic/partials';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  MsalModule,
  MsalInterceptor,
  MsalBroadcastService,
  MsalService,
  MsalGuard,
  MsalRedirectComponent
} from "@azure/msal-angular";
import { InteractionType, PublicClientApplication, BrowserCacheLocation } from "@azure/msal-browser";
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from './services/authentication.service';

export function initializeApp(authService: AuthenticationService) {
  return (): Promise<void> => {
    return authService.checkAndRenewToken();
  }
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    CommonModule,
    SplashScreenModule,
    // SweetAlert2Module.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    //Retrieve Access token
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.clientId,
          authority: environment.authority,
          redirectUri: environment.redirectUri,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: true
        }
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: [`${environment.clientId}/.default`],
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.read']],
          [environment.apiUri, [`${environment.clientId}/.default`]]
        ]),
      }
    ),
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true,
  },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AuthenticationService],
      multi: true,
    }
  ],
  bootstrap: [MsalRedirectComponent, AppComponent],
})
export class AppModule { }
